import React from 'react'

import EditTagForm from '../../modules/Tag/components/EditTagForm'
export default function EditTagPage() {
  return <EditTagForm />
}
